import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * 燃料切れ
 */
const EmptyFuelIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g transform="translate(-12 -416)">
          <rect
            width="40"
            height="40"
            rx="6"
            transform="translate(12 416)"
            fill={CLIENT_SETTINGS.colors.background}
          />
          <path
            d="M191.325,123.66l-.439-.439.026-.028h0l.033-.036a.4.4,0,0,0,.058-.073c.013-.011.026-.021.038-.033a.976.976,0,0,0-.176-1.341l-4.227-4.227a.853.853,0,1,0-1.166,1.166l2.027,2.027-.771,1.858a.429.429,0,0,0,.112.409l1.909,1.91a.429.429,0,0,0,.607,0l.192-.2.109.109v15.732a1.781,1.781,0,0,1-1.057.405,2.027,2.027,0,0,1-1.115-.393v-9.971a.979.979,0,0,0-.977-.977h-2.05V117.28a1.439,1.439,0,0,0-1.435-1.435h-14.75a1.439,1.439,0,0,0-1.435,1.435V145.01h-1.1a.576.576,0,0,0-.574.574v1.687a.576.576,0,0,0,.574.574h19.814a.576.576,0,0,0,.574-.574v-1.687a.576.576,0,0,0-.574-.574h-1.1v-13.5h1.072v9.453a.972.972,0,0,0,.273.678,4.239,4.239,0,0,0,2.8,1.211,3.963,3.963,0,0,0,2.777-1.3.978.978,0,0,0,.235-.636V124.351A.971.971,0,0,0,191.325,123.66Zm-9.805.977a1.439,1.439,0,0,1-1.435,1.435h-8.876a1.439,1.439,0,0,1-1.435-1.435v-4.218a1.439,1.439,0,0,1,1.435-1.435h8.876a1.439,1.439,0,0,1,1.435,1.435Z"
            transform="translate(-146.165 304.155)"
            fill={CLIENT_SETTINGS.colors.main}
          />
        </g>
      </svg>
    </Icon>
  )
}

export default EmptyFuelIcon
